import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import MuiDialogAlert from '../components/MuiDialogAlert';
import LoadingOverlay from 'react-loading-overlay';
import { gramsToKg, kgToGrams, checkNumeric } from '../components/Functions'



const axios = require('axios').default;

const col1_width = "400px";
const col2_width = "70px";


function Settings(props) {
  const [loadingActive, setLoadingActive] = useState(false);
  const [loadingMsg, setLoadingMsg] = useState("Loading Settings ...");

  const [modalBody, setModalBody] = useState("Update Successful");
  const [showModal, setShowModal] = useState(false);
  const [modalHeader, setModalHeader] = useState("");

  const [unlockTime, setUnlockTime] = useState("");
  const [generalWasteThresholdWeight, setGeneralWasteThresholdWeight] = useState("");
  const [recycleWasteThresholdWeight, setRecycleWasteThresholdWeight] = useState("");
  const [fillThresholdPercent, setFillThresholdPercent] = useState("");
  const [smsBinFullEnable, setSmsBinFullEnable] = useState(true);
  const [smsHatchOpenEnable, setSmsHatchOpenEnable] = useState(true);
  const [settingLimit, setSettingLimit] = useState({});

  const handleClose = () => setShowModal(false);

  let navigate = useNavigate();


  useEffect(() => {
    let url = process.env.REACT_APP_API_SERVER + "/load_settings";
    setLoadingActive(true);

    axios.post(url, {
      "settings": "settings",
      "api_user": JSON.parse(localStorage.getItem('user'))
    })
      .then(function (response) {

        if (response.data.status === "API_AUTH_ERROR"){
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }

        if (response.data.status === "OK"){
          setUnlockTime(response.data.UNLOCK_TIME)
          setGeneralWasteThresholdWeight(gramsToKg(response.data.GENERAL_WASTE_THRESHOLD_WEIGHT,0))
          setRecycleWasteThresholdWeight(gramsToKg(response.data.RECYCLE_WASTE_THRESHOLD_WEIGHT,0))
          setFillThresholdPercent(response.data.FILL_THRESHOLD_PERCENT)

          let tmp_json = response.data.SETTINGS_VAL_LIMITS
          setSettingLimit(tmp_json)


          if (response.data.SMS_BIN_FULL_ENABLE === 1) {
            setSmsBinFullEnable(true)
          }
          else {
            setSmsBinFullEnable(false)
          }
  
          if (response.data.SMS_HATCH_OPEN_ENABLE === 1) {
            setSmsHatchOpenEnable(true)
          }
          else {
            setSmsHatchOpenEnable(false)
          }

        }


        setLoadingActive(false)
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [])



  function updateForm(e) {
    let id = e.target.id;
    let val = e.target.value;

    if (id === "UNLOCK_TIME") {
      if (checkNumeric(val)){
        setUnlockTime(val);
      }
    }
    if (id === "FILL_THRESHOLD_PERCENT") {
      if (checkNumeric(val)) { // Check numeric input
        if (val <= settingLimit.FILL_THRESHOLD_PERCENT){ // Check less than 100%
          setFillThresholdPercent(val);
        }
      }

    }
    if (id === "GENERAL_WASTE_THRESHOLD_WEIGHT") {
      if (checkNumeric(val)) { // Check numeric input
        if (val <= settingLimit.GENERAL_WASTE_THRESHOLD_WEIGHT) { // Check less than 200kg
          setGeneralWasteThresholdWeight(val);
        }
      }
    }
    if (id === "RECYCLE_WASTE_THRESHOLD_WEIGHT") {
      if (checkNumeric(val)) { // Check numeric input
        if (val <= settingLimit.RECYCLE_WASTE_THRESHOLD_WEIGHT) { // Check less than 100kg
          setRecycleWasteThresholdWeight(val);
        }
      }
    }
    if (id === "SMS_BIN_FULL_ENABLE") {
      val = e.target.checked;
      setSmsBinFullEnable(val);
    }
    if (id === "SMS_HATCH_OPEN_ENABLE") {
      val = e.target.checked;
      setSmsHatchOpenEnable(val);
    }
  }

  function save_btn_click() {
    let url = process.env.REACT_APP_API_SERVER + "/save_settings";
    setLoadingMsg("Saving Settings ...")
    setLoadingActive(true);

    axios.post(url, {
      "settings": "settings",
      "UNLOCK_TIME": unlockTime,
      "FILL_THRESHOLD_PERCENT": fillThresholdPercent,
      "GENERAL_WASTE_THRESHOLD_WEIGHT": kgToGrams(generalWasteThresholdWeight,0),
      "RECYCLE_WASTE_THRESHOLD_WEIGHT": kgToGrams(recycleWasteThresholdWeight,0),
      "SMS_BIN_FULL_ENABLE": smsBinFullEnable,
      "SMS_HATCH_OPEN_ENABLE": smsHatchOpenEnable,
      "api_user": JSON.parse(localStorage.getItem('user'))
    })
      .then(function (response) {
        setModalHeader("Success")
        setModalBody("Settings Saved")
        setShowModal(true)
        setLoadingActive(false)
      })
      .catch(function (error) {
        setModalHeader("Error: Unable to save settings")
        setModalBody(error)
        setShowModal(true)
      });
  }

  return (
    <div align="left">

      <LoadingOverlay
        active={loadingActive}
        spinner
        text={loadingMsg}
        className="spinner_div"
      >

        <div className="form_area">

          <div className="page_header">Bin Settings</div>

            <table>
              <tbody>
                <tr>
                  <td valign="center" width={col1_width} className="form-labels valign-center">Unlock Time</td>
                  <td align='left' width={col2_width} className='valign-center'>
                    <TextField
                      id="UNLOCK_TIME"
                      onChange={updateForm}
                      variant="outlined"
                      value={unlockTime}
                      size="small"
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                      }}
                    />
                  </td>
                  <td align='left' className='valign-center form-units'>secs</td>
                </tr>
                <tr><td colSpan={4} style={{height: "15px"}}></td></tr>

                <tr>
                  <td className="form-labels valign-center">Fill percent threshold for SMS alert</td>
                  <td align='left' className='valign-center'>
                    <TextField
                      id="FILL_THRESHOLD_PERCENT"
                      onChange={updateForm}
                      variant="outlined"
                      value={fillThresholdPercent}
                      size="small"
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                      }}
                    />

                  </td>
                  <td align='left' className='valign-center form-units'>%</td>
                </tr>
              <tr><td colSpan={4} style={{ height: "15px" }}></td></tr>

                <tr>
                <td className="form-labels valign-center">
                  <div>Weight threshold for SMS alert (General)</div>
                  <div>(Max 200Kg)</div>
                </td>
                  <td align='left' className='valign-center'>
                    <TextField
                      id="GENERAL_WASTE_THRESHOLD_WEIGHT"
                      onChange={updateForm}
                      variant="outlined"
                      value={generalWasteThresholdWeight}
                      size="small"
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                      }}
                    />                    

                  </td>
                  <td align='left' className='valign-center form-units'>Kg</td>
                </tr>
              <tr><td colSpan={4} style={{ height: "15px" }}></td></tr>

                <tr>
                  <td className="form-labels">
                    <div>Weight threshold for SMS alert (Recycled)</div>
                    <div>(Max 100Kg)</div>
                  </td>
                  <td align='left' className='valign-center'>
                    <TextField
                      id="RECYCLE_WASTE_THRESHOLD_WEIGHT"
                      onChange={updateForm}
                      variant="outlined"
                      value={recycleWasteThresholdWeight}
                      size="small"
                      sx={{
                        '& legend': { display: 'none' },
                        '& fieldset': { top: 0 },
                      }}
                    />

                  </td>
                  <td align='left' className='valign-center form-units'>Kg</td>
                </tr>
              <tr><td colSpan={4} style={{ height: "15px" }}></td></tr>

                <tr>
                  <td className='valign-center'>
                    <label className="form-labels form-check-label" htmlFor="SMS_BIN_FULL_ENABLE">Enable SMS alert for bin full</label>
                  </td>
                  <td align='left' colSpan="2" className='valign-center'>
                    <div className="form-check form-switch form-switch-md" style={{ paddingLeft: "10px" }}>
                      <Switch
                        id="SMS_BIN_FULL_ENABLE"
                        onChange={updateForm}
                        checked={smsBinFullEnable}
                      />
                    </div>
                  </td>
                </tr>
              <tr><td colSpan={4} style={{ height: "15px" }}></td></tr>
                <tr>
                  <td className='valign-center'>
                    <label className="form-labels form-check-label" htmlFor="SMS_HATCH_OPEN_ENABLE">Enable SMS alert for hatch open</label>
                  </td>
                  <td align='left' colSpan="2" className='valign-center'>
                    <div className="form-check form-switch form-switch-md" style={{ paddingLeft: "10px" }}>
                      <Switch
                        id="SMS_HATCH_OPEN_ENABLE"
                        onChange={updateForm}
                        checked={smsHatchOpenEnable}
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

            <div style={{ height: "10px" }}></div>

            <div align="left">
            <Button
              variant="contained"
              color="success"
              onClick={save_btn_click}
              sx={{ width: 200, height: 50 }}
            >
              Update Settings
            </Button>

            </div>

            <div style={{ height: "30px" }}></div>


          <MuiDialogAlert
            showModal={showModal}
            handleClose={handleClose}
            bodyContent={modalBody}
            title={modalHeader}
            bodyClass="whitespace"
          />


        </div>
      </LoadingOverlay>

    </div>
  )
}

export default Settings